import { useMutation, useQueryClient } from "@tanstack/react-query";
import { invalidatePortfolioOnForbidden } from "web_myplann/Api/Portfolio/invalidatePortfolioOnForbidden";
import { PortfolioKeys } from "web_myplann/Api/Portfolio/portfolioKeys";
import {
	type ClientRelatedListResponseDTO,
	type ClientRelatedPinRequestDTO,
	postPortfolioIdRelatedV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const usePinPortfolioRelatedMutation = (id: number) => {
	const queryClient = useQueryClient();

	return useMutation<
		ClientRelatedListResponseDTO,
		Error,
		ClientRelatedPinRequestDTO
	>({
		mutationFn: processResponse((requestContract) =>
			postPortfolioIdRelatedV2(requestContract, id),
		),
		onError: (error) => invalidatePortfolioOnForbidden(queryClient, error),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: PortfolioKeys.all });
		},
	});
};
